<template>
  <div class="park-pendtradesman">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Input
              v-model="formItem.key"
              clearable
              style="width:200px"
              placeholder="输入手机号/店铺名称/姓名..."
            ></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="renderTable('formItem')">查找</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <Modal v-model="showModalStatus" title="审核" @on-ok="updateStatus()" :loading="loading">
      <Form :model="review" action="javascript:void(0)">
        <FormItem label="状态">
          <Select v-model="review.status" clearable filterable placeholder="审核状态">
            <Option :value="0">待审核</Option>
            <Option :value="1">通过审核</Option>
            <Option :value="2">未通过审核</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "park-pendtradesman",
  data() {
    return {
      id: null, // 页面agentid
      loading: true,
      dataloading: true,
      title: "",
      pages: {
        page: 1,
        size: 10
      },
      formItem: {
        key: ""
      },
      review: {
        status: "0"
      },
      search_s: {},
      list: [
        {
          title: "园区",
          key: "parkname",
          width: 120,
          render: (h, params) => {
            return h(
              "span",
              params.row.park.name != null ? params.row.park.name : ""
            );
          }
        },
        {
          title: "商户ID",
          key: "agent_uuid",
          width: 350,
          render: (h, params) => {
            return h(
              "span",
              params.row.tradesman != null ? params.row.tradesman.uuid : ""
            );
          }
        },
        {
          title: "店铺名称",
          key: "nickname",
          minWidth: 160,
          render: (h, params) => {
            return h(
              "span",
              params.row.tradesman != null ? params.row.tradesman.nickname : ""
            );
          }
        },
        {
          title: "电话",
          key: "username",
          width: 120,
          render: (h, params) => {
            return h(
              "span",
              params.row.tradesman.data != null
                ? params.row.tradesman.data.phone
                : ""
            );
          }
        },
        {
          title: "状态",
          key: "status",
          width: 120,
          render: (h, params) => {
            return h("span", params.row.status == 0 ? "待审核" : "未通过审核");
          }
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.park_uuid, params.row.trades_uuid);
                    }
                  }
                },
                "删除"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "info",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.showreview(
                        params.row.park_uuid,
                        params.row.trades_uuid,
                        params.row.tradesman.id
                      );
                    }
                  }
                },
                "审核"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      showModalStatus: false
    };
  },
  created: function() {
    this.id = this.$route.params.id;
    this.getTableList();
  },
  components: {},
  watch: {
    "$route.params.id": function(curVal, oldVal) {
      if (curVal) {
        this.id = curVal;
        this.getTableList();
      }
    }
  },
  methods: {
    getTableList: function() {
      this.$api.park
        .pendtradesmanlist({
          page: this.pages.page,
          size: this.pages.size,
          id: this.id
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    // 删除
    remove: function(park_uuid, trades_uuid) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.park
            .tradremove({ trades_uuid: trades_uuid, park_uuid: park_uuid })
            .then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.getTableList();
              }
            });
        }
      });
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        id: this.id
      };
      this.$api.park.pendtradesmanlist(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          for (var i in this.tablelist) {
            this.tablelist[i].phone = this.tablelist[i].data.phone;
            this.tablelist[i].auth_company = this.tablelist[
              i
            ].data.auth_company;
            this.tablelist[i].is_undeline =
              this.tablelist[i].is_undeline == 0 ? "否" : "是";
            this.tablelist[i].cate = this.tablelist[i].cate.name;
          }
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    // 审核
    showreview: function(park_uuid, trades_uuid, id) {
      // 弹出确认框
      this.trades_uuid = trades_uuid;
      this.park_uuid = park_uuid;
      this.tradesman_id = id;
      this.showModalStatus = !this.showModalStatus;
    },
    // 审核
    updateStatus: function(name) {
      this.$api.park
        .reviewtrad({
          status: this.review.status,
          trades_uuid: this.trades_uuid,
          park_uuid: this.park_uuid,
          tradesman_id: this.tradesman_id
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
            this.showModalStatus = !this.showModalStatus;
            this.getTableList();
          }
        });
    }
  }
};
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
}
</style>